import { render, staticRenderFns } from "./SaveButtonTop.vue?vue&type=template&id=1c5272e0&"
import script from "./SaveButtonTop.vue?vue&type=script&lang=js&"
export * from "./SaveButtonTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports